/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { AccountContext } from '../contexts'
import { Logger, LoggerTypes } from '../utils'

export const checkPermissions = (userPermissions) => {
  const allowedPermissions = useContext(AccountContext) || []
  return !allowedPermissions
    ? false
    : allowedPermissions.length === 0
    ? false
    : userPermissions.some((permission) => allowedPermissions.includes(permission))
}

export const AccessControl = ({ userPermissions, renderNoAccess, children }) => {
  const permitted = checkPermissions(userPermissions)

  if (permitted) {
    // Logger.trace(LoggerTypes.ACCESS_CONTROL, 'AccessControl.render(OK)', {
    //   userPermissions,
    //   allowedPermissions: useContext(AccountContext) || []
    // })
    return <>{children}</>
  }
  Logger.trace(LoggerTypes.ACCESS_CONTROL, 'AccessControl.render(KO)', {
    permitted,
    userPermissions,
    allowedPermissions: useContext(AccountContext) || []
  })

  return renderNoAccess()
}

AccessControl.propTypes = {
  userPermissions: PropTypes.array,
  renderNoAccess: PropTypes.func,
  children: PropTypes.node
}

AccessControl.defaultProps = {
  userPermissions: [],
  renderNoAccess: () => null,
  children: null
}

export default AccessControl
